import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M4 1.33331V5.33331H4.00667L4 5.33998L6.66667 7.99998L4 10.6666L4.00667 10.6733H4V14.6666H12V10.6733H11.9933L12 10.6666L9.33333 7.99998L12 5.33998L11.9933 5.33331H12V1.33331H4ZM10.6667 11V13.3333H5.33333V11L8 8.33331L10.6667 11ZM8 7.66665L5.33333 4.99998V2.66665H10.6667V4.99998L8 7.66665Z" />,
  'HourglassEmpty',
  '0 0 16 16',
)
